import React, { useState,useRef,useEffect,useCallback } from 'react';
import { Typography, Button } from 'antd';
import styles from './index.module.scss';
import ios from "@/assets/images/download/ios.png"
import android from "@/assets/images/download/android.png"
import google from "@/assets/images/download/google.png"
import appStore from "@/assets/images/download/appStore.png"
import { useTranslation } from 'react-i18next';
const Privacy: React.FC = () => {
  const {t} = useTranslation();
  function goHref(url:string) {
    window.open(url);
  }
  
  return (
    <div className={styles['download']}>
      <div className={styles["title"]}>{t('Download.DownloadTownloop')}</div>
      <div className={styles["warp"]}>
        <div className={styles["left"]}>
          <div className={styles["p"]}>
            <div className={styles["t"]}>{t('Download.Step1ScantheQRCode')}</div>
            <ul>
              <li>• {t('Download.OpenyourphonecameraoraQRcodescanningapp')}</li>
              <li>• {t('Download.Pointitatthecodeandwaitforthelinkprompt')}</li>
              <li>• {t('Download.Tiptextexample')}"<span>{t('Download.ScantheQRcodetodownloadTownloopinstantly')}</span>"</li>
            </ul>
          </div>

          <div className={styles["p"]}>
            <div className={styles["t"]}>{t('Download.Step2RedirecttotheAppStore')}</div>
            <ul>
              <li>•  {t('Download.iPhoneiPadRedirectstotheAppleAppStore')}</li>
              <li>•  {t('Download.AndroidphonesRedirectstotheGooglePlayStore')}</li>
              <li>•  {t('Download.Theappnameiconscreenshotsandinstallbuttonwillappear')}</li>
            </ul>
          </div> 
          
          <div className={styles["p"]}>
            <div className={styles["t"]}>{t('Download.Step3TaptoDownload')}</div>
            <ul>
              <li>•  {t('Download.TapGetorInstalltostartdownloading')}</li>
              <li>•  {t('Download.Waitforthedownloadtocomplete')}</li>
            </ul>
          </div>

          <div className={styles["p"]}>
            <div className={styles["t"]}>{t('Download.Step4InstallAutomatically')}</div>
            <ul>
              <li>•  {t('Download.Oncedownloaded')}</li>
              <li>•  {t('Download.TapOpentolaunchTownloop')}</li>
              <li>•  {t('Download.Theappmayrequestpermissions')}</li>
            </ul>
          </div>
          <div className={styles["p"]}>
            <div className={styles["t"]}>{t('Download.Step5StartExploring')}</div>
            <ul>
              <li>•  {t('Download.Signuporlogintoyouraccount')}</li>
              <li>•  {t('Download.EnjoyTownloopmainfeatures')}</li>
              <li>•  {t('Download.Examplewelcometext')}"<span>{t('Download.WelcometoTownloop')}</span>"</li>
            </ul>
          </div>




        </div>
        <div className={styles["right"]}>
          <img src={ios} alt="ios" style={{ width: "288px" }} />
          <img src={android} alt="android" style={{ width: "288px" }} />
          <img onClick={()=>goHref('https://apps.apple.com/us/app/townloop/id6753060340')} src={appStore} alt="appStore" style={{ width: "235px", paddingTop: "20px", cursor: "pointer" }} />
          <img onClick={()=>goHref('https://play.google.com/store/apps/details?id=com.bonck.townloop')} src={google} alt="google" style={{ width: "235px", paddingTop: "20px", cursor: "pointer" }} />
        </div>
      </div>
    </div>
  );
};

export default Privacy; 